import type { CardSpendRow } from '../../types/analytics';

export function formatCardTitle(card: Pick<CardSpendRow, 'label' | 'last4'>): string {
  return card.last4 ? `${card.label} · ${card.last4}` : card.label;
}

export function formatAccountKind(type?: string): string {
  if (type === 'credit_card') return 'Credit';
  if (type === 'debit_card') return 'Debit';
  if (type === 'checking') return 'Checking';
  if (type === 'savings') return 'Savings';
  return 'Account';
}

export function isCreditAccount(type?: string): boolean {
  return type === 'credit_card';
}

export function formatDueDate(iso?: string | null): string | null {
  if (!iso) return null;
  const date = new Date(`${iso}T12:00:00Z`);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

export function isDueSoon(iso?: string | null, withinDays = 7): boolean {
  if (!iso) return false;
  const due = new Date(`${iso}T12:00:00Z`);
  if (Number.isNaN(due.getTime())) return false;
  const now = new Date();
  const diff = due.getTime() - Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  return diff >= 0 && diff <= withinDays * 24 * 60 * 60 * 1000;
}

export function moneyOrDash(value?: number | null, format: (n: number) => string): string {
  if (value == null) return '—';
  return format(value);
}
